import { createSelector, filterSelectors } from 'modules/reports/dependencies';

export const isTempReportSelector = createSelector(filterSelectors.decodeReportFilterParamsSelector, reportFilters => {
    return Object.values(reportFilters).some(reportFilterValue => reportFilterValue !== null);
});
